import React from "react";

const KeywordInfo = ({ selectedKeyword, sourceType = "keyword" }) => {
  if (!selectedKeyword) return null;

  return (
    <div className="mb-4 p-3 bg-light rounded">
      <h6 className="text-primary mb-2">
        {sourceType === "url" ? "Selected URL:" : "Selected Keyword:"}
      </h6>
      <p className="fw-bold mb-2 text-break">{selectedKeyword.keyword}</p>
      
      <div className="small text-muted">
        <div><strong>Monthly Searches:</strong> {selectedKeyword.avg_monthly_searches}</div>
        <div><strong>YoY Change:</strong> {Math.round(selectedKeyword.yoy_change * 100) / 100}%</div>
        <div><strong>3-Month Change:</strong> {Math.round(selectedKeyword.three_month_change * 100) / 100}%</div>
      </div>
    </div>
  );
};

export default KeywordInfo;
